export const duplicateMountableProduct = {
	duplicateMountable: "Duplicar montable",
	createNewProduct: "Crear nuevo producto",
	createNewProductDescription: "Duplique el producto montable y edite un nuevo producto",
	importDuplicateInBatch: "Importar duplicado en lote",
	importDuplicateInBatchDescription:
		"Importe la etapa de montable para productos ya creados",
	importDuplicate: "Importar duplicado",
	selectProductsDisclaimer:
		"Seleccione los productos a los que desea importar los datos del montable",
	linkToProducts: "Vincular a productos",
	addProductsToMountable: "Agregue productos para agregar la parte montable",
	addProductsCount: "Agregar {{countProducts}} productos",
	duplicateConfirmation: "Confirmación de duplicado",
	selectedProducts:
		"Se ha seleccionado ({{countProducts}}) producto(s) para duplicar las etapas de montables.",
	finishStep: "¿Desea concluir la adición de las etapas?",
	finishStepNote:
		"OBS: si productos montables fueron seleccionados tendrán sus etapas actuales reemplazadas.",
	backStage: "Volver etapa",
	confirmDuplicate: "Confirmar duplicado",
	successMessage: "Se agregaron etapas de montable en productos de la lista.",
};
